module.exports = __webpack_public_path__ + "static/media/NickyLaatz.a57ba616.woff2";